export default __webpack_public_path__ + "static/chart-032097a8605a26c19f4ec7c9f5c89c64.svg";